import { ControllerBase } from "controllerBase";
import global from 'globalMU'
const ko = require('knockout')


declare var window:any

const EditarLoteProdutoController = ControllerBase.extend({
    name: "EditarLoteProdutoController",

    framework: "knockout",

    ajax: function () {

        return {
            url: "/Orcamento/_EditarLoteProduto",
            type: "post",
            cache: false
        };
    },

    antesBinding: function () {
        this.appendToModel({
            name: "QuantidadeFaltante",
            value: this.model.Produto().QuantidadePedida() - this.model.Produto().QuantidadeReservada()
        });
    },

    aposBinding: function () {

        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });
    },
    salvar: function () {
        var self = this;

        var lote = this.toJS(this.model.Lote());
        lote.QuantidadeReservar = $("#editarLoteProduto_QuantidadeReservar").val(); // FNX-5571

        lote.CodigoObjetoItemOrcamento = this.codigoObjetoItemOrcamento;

        global.ajax({
            url: "/Orcamento/ReservarLote",
            type: "post",
            data: {
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                lote: lote
            },
            success: function (data) {
                if (!data) {
                    return;
                }
                if (!data.HasErrors) {

                    self.produto.QuantidadeReservada(data.QuantidadeReservada);
                    //419726 - Não precisa atualizar --- self.orcamento.atualizarItem(data.ItensOrcamento);

                    var m = ko.mapping.fromJS(data.Lotes.Entities);

                    self.produto.Lotes().Entities(m());

                    global.showSuccessMessage("Lote reservado com sucesso");

                    if (self.finalizarCallback) {
                        self.finalizarCallback();
                    }
                } else {
                    if (data.QuantidadeReservar)
                        self.model.Lote().QuantidadeReservar(data.QuantidadeReservar);
                    $("#editarLoteProduto_QuantidadeReservar").focus();
                }

            }
        });

    }

});

window.EditarLoteProdutoController = EditarLoteProdutoController

export {EditarLoteProdutoController}